import { ActiveModel } from "./active-model";

// ----------------------------------------------------------------------

export type LibraryFilter = "todos" | "topico" | "oral" | "veiculo" | "favoritos";

export const LIBRARY_FILTER_OPTIONS: Array<{ value: LibraryFilter; label: string }> = [
  { value: "todos", label: "Tudo" },
  { value: "topico", label: "Tópico" },
  { value: "oral", label: "Oral" },
  { value: "veiculo", label: "Veículos" },
  { value: "favoritos", label: "Favoritos" },
];

const normalize = (value: string | null | undefined) =>
  (value ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

export const isOral = (item: ActiveModel) => normalize(item.type) === "oral";
export const isVehicle = (item: ActiveModel) => normalize(item.type) === "veiculo";

export function filterActives(items: ActiveModel[], query: string, filter: LibraryFilter): ActiveModel[] {
  const q = normalize(query.trim());
  return items.filter((item) => {
    if (filter === "topico" && (isOral(item) || isVehicle(item))) return false;
    if (filter === "oral" && !isOral(item)) return false;
    if (filter === "veiculo" && !isVehicle(item)) return false;
    if (filter === "favoritos" && !item.favorite) return false;
    if (!q) return true;
    return [item.name, item.mechanismAction, item.annotation].some((field) => normalize(field).includes(q));
  });
}

export function filterByType(items: ActiveModel[], filter: LibraryFilter): ActiveModel[] {
  if (filter === "todos") return items;
  return items.filter((item) => {
    if (filter === "topico") return !isOral(item) && !isVehicle(item);
    if (filter === "oral") return isOral(item);
    if (filter === "veiculo") return isVehicle(item);
    if (filter === "favoritos") return !!item.favorite;
    return true;
  });
}

export function filterToQueryParams(filter: LibraryFilter): { type?: "topico" | "oral" | "veiculo"; onlyFavorites?: boolean } {
  if (filter === "topico") return { type: "topico" };
  if (filter === "oral") return { type: "oral" };
  if (filter === "veiculo") return { type: "veiculo" };
  if (filter === "favoritos") return { onlyFavorites: true };
  return {};
}
